<template>
  <v-dialog v-model="mainDialog" scrollable max-width="800px">
    <v-card color="rgb(20,20,20)" dark class="pt-6">
      <v-card-title class="mt-0 pt-0 text-h5">
        Frequently Asked Questions
      </v-card-title>
      <v-card-text class="pb-0">
        <strong class="text-h6 white--text">What is Trast.live?</strong>

        <p>
          Trast is a low latency, high quality screen sharing service for you
          and your friends.
        </p>

        <strong class="text-h6 white--text">My room has no audio!</strong>

        <p>
          Make sure to tick the <b class="white--text">Share Audio</b> checkbox
          when streaming.
        </p>
        <v-img
          max-height="400px"
          contain
          :src="require('@/assets/shareaudio.png')"
        ></v-img>
        <p class="mt-4">
          <b class="white--text">Note</b>, only Chromium based browsers are
          supported at this time due to limitations in other browsers.
        </p>

        <strong class="text-h6 white--text">Why am I hearing an echo?</strong>
        <p>
          You are likely hearing your streamed audio from its source as well as
          Trast.<br />Either <b class="white--text">mute the Trast player</b> or
          <b class="white--text">mute the source</b>.
        </p>

        <strong class="text-h6 white--text"
          >How do I invite someone to my room?</strong
        >
        <p>
          Viewers can join your room using your individual
          <b class="white--text">Room URL</b>, for example
          <b class="grey--text text--lighten-2">https://trast.live/</b
          ><b class="white--text">Username</b>
        </p>
        <p>
          If you're hosting a <b class="white--text">Private Room</b>, you must
          first add the person to your friends list through the sidebar.
        </p>
        <v-img
          max-height="400px"
          contain
          class="mb-4"
          :src="require('@/assets/addFriend.png')"
        ></v-img>

        <strong class="text-h6 white--text"
          >How do I open a public room?</strong
        >
        <p>
          Public rooms are an exclusive feature for
          <a
            class="white--text text-decoration-underline"
            href="https://www.patreon.com/join/trast?"
            target="_blank"
            ><b>Subscribers</b></a
          >, as they're all automatically routed through our bespoke
          <b class="white--text">relay server</b>.
        </p>

        <strong class="text-h6 white--text"
          >Why can't my friends see my stream?</strong
        >
        <p>
          The most likely cause is a
          <b class="white--text">privacy extension</b> on the host's / viewer's
          chrome install.<br />Try hosting in incognito mode to see if that
          solves the problem.
          <br />
          <b class="white--text">Note</b>, VPNs (like the one built into Opera)
          can cause issues with connection.
        </p>

        <strong class="text-h6 white--text"
          >Why is the video is lagging / having problems?</strong
        >

        <p>
          <b class="white--text"
            >The number of viewers a host can stream to depends on the
            capability of their computer and network.</b
          ><br />
          Default users connect to each other through a P2P connection. For
          every user, the host creates and uploads a video stream. When either
          the host's CPU or bandwidth hits its limit, the connection will start
          to have issues. <br /><br />
          Every
          <a
            class="white--text text-decoration-underline"
            href="https://www.patreon.com/join/trast?"
            target="_blank"
            ><b>Subscriber</b></a
          >
          room is routed through our bespoke
          <b class="white--text">relay server</b> which offsets the CPU and
          bandwidth usage, making for a
          <b class="white--text">much smoother stream to many more people</b>.
        </p>

        <strong class="text-h6 white--text"
          >How can I subscribe to Trast?</strong
        >

        <p>
          Trast has a
          <a
            class="white--text text-decoration-underline text-subtitle-1"
            href="https://www.patreon.com/join/trast?"
            target="_blank"
            ><b>Patreon</b></a
          >
          which unlocks immediate site benefits such as usage of the
          <b class="white--text">Relay Server</b>,
          <b class="white--text">Public Rooms</b> and
          <b class="white--text">Chat GIFS</b>.
        </p>

        <strong class="text-h6 white--text">Where can I get help?</strong>

        <p>
          Trast has a very active
          <a
            class="white--text text-decoration-underline text-subtitle-1"
            href="https://discord.com/invite/uMXKJRG"
            target="_blank"
            >Discord Server</a
          >.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="light-green" text @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style></style>

<script>
export default {
  data: () => ({
    mainDialog: false
  }),

  methods: {
    open() {
      this.mainDialog = true;
    },
    close() {
      this.mainDialog = false;
    }
  }
};
</script>
